import { defineStore } from 'pinia'

export const kioskAuthState = defineStore({
  id: 'kioskAuth',
  state: () => {
    return {
      device: JSON.parse(localStorage.getItem('user')) ?? null,
      token: localStorage.getItem('accessToken') ?? null,
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'authStorage',
        storage: sessionStorage, // You can also use sessionStorage or custom storage
      },
    ],
  },
  getters: {
    //
  },
  actions: {
    setDevice(device) {
      //    
    },
    setToken(token) {
      if (token) {
        localStorage.setItem('accessToken', token)
        this.token = token
      } else {
        this.token = null
        localStorage.removeItem('accessToken')
      }
    },
    async fetchDevice() {
      //
    },
    async login(credentials) {
      //
    },
    async logout() {
      //
    },
  },
  computed: {
    device: state => state.device,
    token: state => state.token,
  },
})
